import request from "@/utils/request";

// 获取车辆的在线状态
export function getVehicleOnlineStatus(vehicleId) {
  return request({
    url: "/cloud/monitor/vehicle/isOnline?vehicleId=" + vehicleId,
    method: "get"
  });
}

// 统计在线车辆数量
export function countVehicleOnlineStatus() {
  return request({
    url: "/cloud/monitor/vehicle/online/count",
    method: "get",
  });
}


// 测试任务车辆列表
export function testingTaskVehicleList(params) {
  return request({
    url: "/cloud/testing/task/vehiclePages",
    method: "post",
    data: params
  });
}

// 测试任务车辆信息
export function getTestingTaskVehicleInfo(testingTaskId) {
  return request({
    url: "/cloud/testing/task/vehicleInfo?testingTaskId=" + testingTaskId,
    method: "get"
  });
}
// 测试任务路线信息
export function getTestingTaskRouteInfo(testingTaskId) {
  return request({
    url: "/cloud/testing/task/routes?testingTaskId=" + testingTaskId,
    method: "get"
  });
}
